<div class="Stepper">
  <ng-container *ngFor="let step of steps; let i = index">
    <ng-container *ngTemplateOutlet="step.template"></ng-container>
  </ng-container>
</div>